import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "menu-name" }

import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import saveAs from 'file-saver';
import http from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';

interface Props {
  // 画面遷移先
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  link: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMenuButton',
  props: {
    link: {}
  },
  emits: ['openDialog', 'openSidebar', 'deleteSidebar'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const router = useRouter();

const emit = __emit;

/**
 * 画面遷移
 */
const menuLink = () => {
  if (props.link.link) {
    emit('deleteSidebar');
    router.push({ name: props.link.link });
  }
};

// マニュアルダウンロード
const download = () => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('manual_type', 'admin');

  // ファイル存在チェック
  http
    .post('/ctp001001/existManualFile', formData)
    .then((response) => {
      switch (response.data.common.status) {
        // 結果ステータス：正常終了
        case ResultStatusCode.SUCCESS:
          switch (response.data.common.detail_status) {
            // 詳細結果ステータス：正常終了
            case DetailResultStatusCode.SUCCESS:
              // マニュアルダウンロード
              saveAs(response.data.path, response.data.fileName);
              break;
            // 詳細結果ステータス：正常終了（メッセージ）
            case DetailResultStatusCode.SUCCESS_MESSAGE:
              // ダイアログ表示
              emit('openDialog', true);
              break;
            default:
              break;
          }
          break;
        // 結果ステータス：異常終了
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
          break;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// メニュークリック
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const menuClick = (item: any) => {
  if (item.name !== '') {
    // マスメンTOPに戻るときはサイドバーを閉じる
    if (item.name === 'masterTop') {
      emit('openSidebar');
    } else {
      emit('deleteSidebar');
    }
    router.push({ name: item.name, params: { type: item.type } });
  } else {
    download();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    flat: "",
    color: "white",
    class: "menu-button",
    onClick: menuLink
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_icon, {
        left: "",
        name: _ctx.link.icon
      }, null, 8, ["name"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.link.name), 1),
      _createVNode(_component_q_menu, {
        "transition-show": "jump-down",
        "transition-hide": "jump-up",
        class: "header-submenu"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.link.menu, (item, index) => {
                return (_openBlock(), _createBlock(_component_q_item, {
                  key: index,
                  clickable: "",
                  onClick: ($event: any) => (menuClick(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})